"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WatcherFieldLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _alloyReactTooltip = _interopRequireDefault(require("@adsk/alloy-react-tooltip"));
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _useTranslations = require("../../utils/i18n/useTranslations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const WatcherFieldLabel = () => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, T.translate("issueAttributes.watchers"), /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.default, {
    style: {
      width: 200
    },
    placement: _alloyReactTooltip.default.PLACEMENTS.RIGHT,
    variant: _alloyReactTooltip.default.VARIANTS.DARK,
    content: T.translate("issueCreation.watchers.tooltip")
  }, /*#__PURE__*/_react.default.createElement(_alloyReactIcon.AlertInformationIcon, {
    size: 16,
    style: {
      marginTop: 5,
      marginLeft: 5,
      color: _alloyReactTheme.default.colors.adskBlue700
    }
  })));
};
exports.WatcherFieldLabel = WatcherFieldLabel;
//# sourceMappingURL=WatcherFieldLabel.js.map